import apiFetch from '../apiFetch'

export default function (dossierId, token, filter) {
  return apiFetch({ endPoint: `documentHistorical/UploadedAll?dossierHistoricalId=${dossierId}`, method: 'POST', token: token, body: filter })
}
